import { IDashboardLayout } from 'components/Visualization/CDashboard/types';

import {
  blueprintDashboardSummaryWidgets,
  blueprintDashboardWidgets,
} from './widget';

export const blueprintDashboardConfig: IDashboardLayout = {
  id: 'blueprint_dashboard',
  title: 'Blueprint Dashboard d',
  widgets: [
    {
      type: 'card',
      i: 'generalDetails',
      x: 0,
      y: 0,
      w: 7.8,
      h: 7,
      isResizable: false,
      static: true,
    },
    {
      type: 'card',
      i: 'clouds',
      x: 7.8,
      y: 0,
      w: 1.4,
      h: 3.5,
      isResizable: false,
      static: true,
    },
    {
      type: 'card',
      i: 'environments',
      x: 9.2,
      y: 0,
      w: 1.4,
      h: 3.5,
      isResizable: false,
      static: true,
    },
    {
      type: 'card',
      i: 'accounts',
      x: 10.6,
      y: 0,
      w: 1.4,
      h: 3.5,
      isResizable: false,
      static: true,
    },
    {
      type: 'card',
      i: 'policies',
      x: 7.8,
      y: 3.5,
      w: 1.4,
      h: 3.5,
      isResizable: false,
      static: true,
    },
    {
      type: 'card',
      i: 'exceptions',
      x: 9.2,
      y: 3.5,
      w: 1.4,
      h: 3.5,
      isResizable: false,
      static: true,
    },
    {
      type: 'card',
      i: 'workflows',
      x: 10.6,
      y: 3.5,
      w: 1.4,
      h: 3.5,
      isResizable: false,
      static: true,
    },
  ],
  available: blueprintDashboardWidgets,
};

export const blueprintDashboardSummaryConfig: IDashboardLayout = {
  id: 'blueprint_summary_dashboard',
  title: 'Blueprint Summary Dashboard',
  widgets: [
    {
      type: 'pie',
      i: 'violationsByEnvironments',
      x: 0,
      y: 0,
      w: 3.5,
      h: 8,
      isResizable: false,
      static: true,
    },
    {
      type: 'pie',
      i: 'violationsByAccounts',
      x: 3.5,
      y: 0,
      w: 3.5,
      h: 8,
      isResizable: false,
      static: true,
    },
    {
      type: 'area',
      i: 'passPercentageByEnvironments',
      x: 7,
      y: 0,
      w: 5,
      h: 8,
      isResizable: false,
      static: true,
    },
  ],
  available: blueprintDashboardSummaryWidgets,
};
